
import * as CountryCityStatePackage from 'countrycitystatejson';

const { getCountries, getStatesByShort } = CountryCityStatePackage;

const countries = (getCountries && typeof getCountries === 'function') ? getCountries() : [];

const processedCountriesData = countries.map(country => {
  let states = [];
  let countryIdentifier;

  if (country && country.shortName) {
    countryIdentifier = country.shortName;
  } else if (country && country.isoCode) {
    countryIdentifier = country.isoCode;
  } else if (country && country.id) {
    countryIdentifier = country.id;
  }

  if (getStatesByShort && typeof getStatesByShort === 'function' && countryIdentifier) {
    try {
      states = getStatesByShort(countryIdentifier) || [];
      if (!Array.isArray(states)) {
        states = states ? [states.toString()] : [];
      }
    } catch (e) {
      states = [];
    }
  } else {
    states = [];
  }

  return {
    name: country.name,
    shortName: countryIdentifier,
    phoneCode: country.phone ? `+${country.phone}` : '',
    provinces: Array.isArray(states) ? states.sort() : [],
  };
}).sort((a, b) => (a.name || '').localeCompare(b.name || ''));

export default processedCountriesData;
